import api from '@/core/api/client';

export interface ModuleDefinition {
  id: string;
  name: string;
  description?: string;
  type: 'core' | 'addon' | 'experimental';
  featureKey?: string;
  required?: boolean;
  environments?: string[] | 'all';
  plans?: string[];
  sidebarOrder?: number;
  parentNavId?: string;
  path?: string;
  listensToGroupEvents?: boolean;
}

export interface ModulesListResponse {
  success: boolean;
  data: {
    modules: ModuleDefinition[];
    environment: string;
    groupEventListeners: string[];
  };
}

export interface AvailableModuleForProduct {
  featureKey: string;
  name: string;
  description?: string;
}

export interface AvailableForProductResponse {
  success: boolean;
  data: AvailableModuleForProduct[];
}

export const modulesService = {
  async list(): Promise<ModulesListResponse['data']> {
    const { data } = await api.get<ModulesListResponse>('/modules');
    if (!data.success || !data.data) throw new Error('Erro ao carregar módulos');
    return data.data;
  },

  async getAvailableForProduct(productId?: string): Promise<AvailableModuleForProduct[]> {
    const params = productId ? { productId } : {};
    const { data } = await api.get<AvailableForProductResponse>('/modules/available-for-product', { params });
    if (!data.success || !Array.isArray(data.data)) throw new Error('Erro ao carregar módulos disponíveis');
    return data.data;
  },
};
